import * as schema from '@dupe/data/schema'
import { createPool, sql } from '@vercel/postgres'
import { withReplicas } from 'drizzle-orm/pg-core'
import { drizzle } from 'drizzle-orm/vercel-postgres'

// SAFETY: Prevent database connections during tests
if (process.env.NODE_ENV === 'test') {
  throw new Error(
    '🚨 SAFETY: Database connections are not allowed during tests. ' +
    'Please mock the database calls in your test files. ' +
    'See CLAUDE.md for proper mocking patterns.'
  )
}

// top level exports so we can just
// import everything from ~/src/db
export * from 'drizzle-orm'
export * as schema from '@dupe/data/schema'

const primaryDb = drizzle(sql, { schema })

// Check if read replica URL is available
const readReplicaUrl = process.env.POSTGRES_URL_READ_REPLICA_A
let readReplicaDb = null

if (readReplicaUrl) {
  // Create a new pool for the read replica
  const readReplicaPool = createPool({ connectionString: readReplicaUrl })
  readReplicaDb = drizzle(readReplicaPool, { schema })
}

// Configure db with read replica if available
export const db = readReplicaDb
  ? withReplicas(primaryDb, [readReplicaDb])
  : primaryDb

// if (readReplicaDb) {
//   console.info(`🔄 Starting Drizzle (WEB) with read replicas`)
// }
